var deprecate = require('depd')('allhomes-api');
export default deprecate;